/* ============================================================================
   « Mes tailles » / « Appliquer mes marques » dans les filtres Boost — §37
   Fichier : assets/parad-prefs-filtres.js
   Rendu par snippets/custom-prefs-filtres.liquid (pages collection, layout/theme.liquid).

   Principe (modèle : momox fashion). Dans le panneau du filtre Taille
   (pf_opt_taille) et du filtre Marque (pf_v_marque) rendus par Boost, on insère
   un bouton qui applique d'un coup les préférences enregistrées par la cliente
   (métachamps custom.preferences_tailles / custom.preferences_marques, lus en
   Liquid par le snippet et exposés dans window.PARAD_PREFS_FILTRES).

     - préférences VIDES (ou cliente non connectée) → le bouton ouvre la page
       « Mes préférences » ;
     - préférences PRÉSENTES → le bouton ajoute les valeurs à l'URL de la
       collection, en paramètre pf_* RÉPÉTÉ (une occurrence par valeur : Boost
       n'a pas d'API JS de filtrage et ignore la forme « a,b », cf. §10) ; si
       elles sont déjà toutes appliquées, un second clic les retire (bascule) ;
     - préférences PRÉSENTES → une roue crantée à côté du bouton mène à la page
       « Mes préférences » pour les modifier.

   Règle du chantier Boost : tout ce qu'on pose dans son DOM est jetable, il
   reconstruit l'arbre de filtres à chaque filtre appliqué. L'insertion est donc
   idempotente et rejouée par une MutationObserver, et l'état « appliqué » est
   relu dans l'URL à chaque passage, jamais mémorisé dans le DOM.
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.PARAD_PREFS_FILTRES || {};
  var sizeMap = window.PARAD_SIZE_MAP || {};
  var PREFS_URL = cfg.prefsUrl || '/pages/mes-preferences';

  /* Une section de filtre Boost (desktop horizontal ET panneau mobile : le même
     filtre est rendu deux fois, une par arbre) et son conteneur d'options. */
  var SECTION = '.boost-sd__filter-option[data-filteroptionid]';
  var HOST = '.boost-sd__filter-option-itemwrapper';

  /* @test:start toArray */
  // Métachamp list.single_line_text_field : Liquid `| json` émet un tableau, ou
  // null s'il est absent. On tolère aussi une chaîne JSON, et tout le reste
  // devient []. Les valeurs sont nettoyées (chaînes non vides, sans blancs).
  function toArray(v) {
    if (Array.isArray(v)) {
      return v
        .filter(function (x) { return typeof x === 'string' && x.trim(); })
        .map(function (x) { return x.trim(); });
    }
    if (typeof v === 'string') {
      try { return toArray(JSON.parse(v)); } catch (e) { return []; }
    }
    return [];
  }
  /* @test:end */

  /* @test:start toBoostSize */
  // Code enregistré (S, M…) → libellé COMPLET de l'option Boost (« T1 - S - 36 »),
  // seule forme que pf_opt_taille accepte. Une valeur déjà sous cette forme
  // passe telle quelle ; un code inconnu est ignoré (un filtre incomplet vaut
  // mieux qu'une valeur qui ne correspond à rien et ne renvoie aucun produit).
  function toBoostSize(map, code) {
    var c = String(code == null ? '' : code).trim();
    if (!c) return null;
    if (map[c]) return map[c];
    if (map[c.toUpperCase()]) return map[c.toUpperCase()];
    return /^T\d+\s*-\s*/.test(c) ? c : null;
  }
  /* @test:end */

  /* @test:start isApplied */
  // « Appliqué » = TOUTES nos valeurs figurent parmi les valeurs courantes du
  // paramètre. D'autres valeurs cochées à la main peuvent coexister.
  function isApplied(current, values) {
    if (!values.length) return false;
    return values.every(function (v) { return current.indexOf(v) !== -1; });
  }
  /* @test:end */

  /* @test:start nextSearch */
  // Query string cible. on=true : ajoute nos valeurs (sans doublon) à celles
  // déjà présentes ; on=false : retire nos valeurs SEULEMENT, les autres
  // restent. `page` est remis à zéro (un résultat plus court n'a pas de page 3).
  // Les autres paramètres (sort_by, autres pf_*) sont conservés tels quels.
  function nextSearch(search, key, values, on) {
    var p = new URLSearchParams(search);
    var cur = p.getAll(key);
    p.delete(key);
    p.delete('page');
    var next = on
      ? cur.concat(values.filter(function (v) { return cur.indexOf(v) === -1; }))
      : cur.filter(function (v) { return values.indexOf(v) === -1; });
    next.forEach(function (v) { p.append(key, v); });
    var qs = p.toString();
    return qs ? '?' + qs : '';
  }
  /* @test:end */

  /* @test:start libelle */
  // Libellé du bouton (point d'équipe du 25/09/2026) : sans préférence — cliente
  // non connectée, ou connectée sans rien d'enregistré — le bouton mène à la
  // page « Mes préférences » ; il le dit (« Renseigner mes tailles ») au lieu
  // d'annoncer un filtre qui n'existe pas encore (« Mes tailles »).
  function libelle(values, plein, vide) {
    return values && values.length ? plein : vide;
  }
  /* @test:end */

  var tailles = toArray(cfg.tailles)
    .map(function (c) { return toBoostSize(sizeMap, c); })
    .filter(Boolean);
  var marques = toArray(cfg.marques);

  /* Icônes Material Design (Apache 2.0) : règle, étiquette, roue crantée.
     Constantes du fichier — jamais d'entrée externe dans un innerHTML. */
  var ICONS = {
    ruler: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"/></svg>',
    gear: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/></svg>'
  };

  /* Les deux groupes, par id de filtre Boost (= clé du paramètre d'URL, confirmé
     en réel au §14). `values` = ce qu'on pousse dans l'URL. */
  var GROUPS = {
    pf_opt_taille: { cls: 'taille', label: 'Mes tailles', labelVide: 'Renseigner mes tailles', nom: 'tailles', icon: ICONS.ruler, values: tailles },
    pf_v_marque:   { cls: 'marque', label: 'Appliquer mes marques', labelVide: 'Renseigner mes marques', nom: 'marques', icon: ICONS.tag, values: marques }
  };

  function currentValues(key) {
    try { return new URLSearchParams(window.location.search).getAll(key); } catch (e) { return []; }
  }

  function build(key, g) {
    var wrap = document.createElement('div');
    wrap.className = 'parad-pf parad-pf--' + g.cls;
    wrap.setAttribute('data-parad-pf', key);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'parad-pf__btn';
    btn.setAttribute('data-parad-pf-btn', key);
    btn.innerHTML = g.icon + '<span class="parad-pf__label"></span>';
    wrap.appendChild(btn);

    /* Roue crantée seulement quand il y a quelque chose à modifier : sans
       préférence, le bouton principal mène déjà à la page. */
    if (g.values.length) {
      var gear = document.createElement('a');
      gear.className = 'parad-pf__gear';
      gear.href = PREFS_URL;
      gear.title = 'Modifier mes préférences';
      gear.setAttribute('aria-label', 'Modifier mes préférences');
      gear.innerHTML = ICONS.gear;
      wrap.appendChild(gear);
    }
    return wrap;
  }

  /* État visuel relu depuis l'URL — jamais stocké. */
  function sync(wrap, key, g) {
    var btn = wrap.querySelector('.parad-pf__btn');
    var lbl = wrap.querySelector('.parad-pf__label');
    if (!btn || !lbl) return;
    var on = isApplied(currentValues(key), g.values);
    var pressed = on ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
    var texte = libelle(g.values, g.label, g.labelVide);
    if (lbl.textContent !== texte) lbl.textContent = texte;
    var title = !g.values.length
      ? 'Renseigner mes ' + g.nom + ' dans « Mes préférences »'
      : (on ? 'Retirer mes ' + g.nom + ' du filtre' : g.values.join(', '));
    if (btn.title !== title) btn.title = title;
  }

  /* Idempotent : insère le bloc s'il manque, resynchronise l'état sinon. */
  function inject() {
    document.querySelectorAll(SECTION).forEach(function (section) {
      var key = (section.getAttribute('data-filteroptionid') || '').toLowerCase();
      var g = GROUPS[key];
      if (!g) return;
      var host = section.querySelector(HOST);
      if (!host) return;
      var wrap = section.querySelector('.parad-pf[data-parad-pf]');
      if (!wrap) {
        wrap = build(key, g);
        host.insertBefore(wrap, host.firstChild);
      }
      sync(wrap, key, g);
    });
  }

  /* Page d'où l'on part vers « Mes préférences » : son bouton « Revenir au
     shopping » y ramène même quand la connexion (hébergée par Shopify, autre
     domaine) s'est intercalée et qu'un simple retour arrière n'y suffit plus. */
  function memoriserRetour() {
    try { window.sessionStorage.setItem('parad_retour_shopping', window.location.href); } catch (e) {}
  }

  /* Clics en CAPTURE au niveau document : Boost écoute lui aussi les clics au
     niveau document (data-action / data-metadata) — on lui cache les nôtres. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.parad-pf__btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var key = btn.getAttribute('data-parad-pf-btn');
      var g = GROUPS[key];
      if (!g) return;
      if (!g.values.length) { memoriserRetour(); window.location.assign(PREFS_URL); return; }
      var on = !isApplied(currentValues(key), g.values);
      window.location.assign(window.location.pathname + nextSearch(window.location.search, key, g.values, on));
      return;
    }
    /* La roue crantée est un lien : il navigue normalement, Boost n'en sait rien. */
    if (t.closest('.parad-pf__gear')) { memoriserRetour(); e.stopPropagation(); }
  }, true);

  /* Diagnostic (console) : paradPfDebug() → préférences résolues, URL, sections vues. */
  window.paradPfDebug = function () {
    var info = {
      tailles: tailles, marques: marques, prefsUrl: PREFS_URL, search: window.location.search,
      sections: Array.prototype.map.call(document.querySelectorAll(SECTION), function (s) {
        return s.getAttribute('data-filteroptionid') + (s.querySelector('.parad-pf') ? '  [bouton posé]' : '');
      })
    };
    if (window.console) console.log('[parad-pf]', info);
    return info;
  };

  var mo, timer;
  function refresh() {
    if (mo) mo.disconnect();
    inject();
    if (mo && document.body) mo.observe(document.body, { childList: true, subtree: true });
  }
  function init() {
    if (!document.body) return;
    inject();
    mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 120); });
    mo.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', function () { clearTimeout(timer); timer = setTimeout(refresh, 0); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
